import { useNavigate, useParams } from "react-router-dom";
import ProjectEstimate from "./components/ProjectEstimate";
import { useReadProjectGroupsItemSheetOriginalList } from "@/libs/react-query/hooks/useItemsheetsQuery";
import { useEffect, useMemo } from "react";
import { ProjectType } from "@/consts/Project";
import { useSetSelectedOriginalInfo } from "./hooks/useTabStore";

export default function DirectEstimatePage() {
  const { group_id, estimate_id, original_id, itemsheet_id } = useParams();
  const navigate = useNavigate();

  const setSelectedOriginalInfo = useSetSelectedOriginalInfo();

  const { data: originals, isError } =
    useReadProjectGroupsItemSheetOriginalList(group_id || "");

  const selectedOriginal = useMemo(() => {
    if (!originals) return null;

    const { proj_originals: projArr = [], prcr_originals: prcrArr = [] } =
      originals;

    if (projArr.some((item) => item.id === original_id)) {
      setSelectedOriginalInfo({
        projectId: estimate_id,
        projectType: ProjectType.PROJ,
        originalId: original_id,
        latestSheetId: itemsheet_id,
      });
      return projArr.find((item) => item.id === original_id);
    } else if (prcrArr.some((item) => item.id === original_id)) {
      setSelectedOriginalInfo({
        projectId: estimate_id,
        projectType: ProjectType.PRCR,
        originalId: original_id,
        latestSheetId: itemsheet_id,
      });
      return prcrArr.find((item) => item.id === original_id);
    }
  }, [originals]);

  if (!group_id || !estimate_id || !original_id || !itemsheet_id || isError) {
    navigate("/404", { replace: true });
    return null;
  }

  return (
    <div className="mt-6">
      {selectedOriginal && (
        <ProjectEstimate selectedOriginal={selectedOriginal} />
      )}
    </div>
  );
}
